// extracted by mini-css-extract-plugin
module.exports = {"loginContainer":"SendEmail_loginContainer__3tFXB","input":"SendEmail_input__X8lkz","errorMsg":"SendEmail_errorMsg__NM4Y-"};